class HelpCenter extends HTMLElement {
    constructor() {
        super();

        this.details = [...this.querySelectorAll('details')].filter(x => x.dataset.target && x.dataset.target.length);

        this.bindClicks();
    }

    bindClicks() {
        if (this.details.length) {
            for (const detail of this.details) {
                detail.addEventListener('click', this.clickHandler.bind(this));
            }
        }
    }

    clickHandler(e) {
        let details = e.target.closest('details');

        window.location = details.dataset.target;
    }
}

customElements.define('help-center', HelpCenter);

class HelpCenterSidebar extends HTMLElement {
    constructor() {
        super();

        let openner = this.querySelector('.help-center--sidebar-openner');
        let current = this.querySelector('.current .accordion__title').innerHTML;
        let opennerSummary = openner.querySelector('summary .accordion__title');
        let originalHeading = opennerSummary.innerHTML;

        if (window.innerWidth <= 750) {
            openner.open = false;

            openner.addEventListener('toggle', e => {
                if (e.target.open) {
                    opennerSummary.innerHTML = originalHeading;
                } else {
                    opennerSummary.innerHTML = current;
                }
            })
        }
    }
}

customElements.define('help-center-sidebar', HelpCenterSidebar);